"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Represents an import node.
 *
 * @author Fabien Potencier <fabien@symfony.com>
 */
const node_1 = require("../node");
class TwingNodeImport extends node_1.TwingNode {
    constructor(expr, varName, lineno, columnno, tag = null) {
        let nodes = new Map();
        nodes.set('expr', expr);
        nodes.set('var', varName);
        super(nodes, new Map(), lineno, columnno, tag);
        this.type = node_1.TwingNodeType.IMPORT;
    }
    compile(compiler) {
        compiler
            .addDebugInfo(this)
            .subcompile(this.getNode('var'), false)
            .raw(' = ');
        if (this.getNode('expr').getType() === node_1.TwingNodeType.EXPRESSION_NAME && this.getNode('expr').getAttribute('name') === '_self') {
            compiler.raw('this');
        }
        else {
            compiler
                .raw('this.loadTemplate(')
                .subcompile(this.getNode('expr'))
                .raw(', ')
                .repr(this.getTemplateName())
                .raw(', ')
                .repr(this.getTemplateLine())
                .raw(')');
        }
        compiler.raw(";\n");
    }
}
exports.TwingNodeImport = TwingNodeImport;
